import api from './api';

const bannerService = {
  getBanners: (payload = {}) => {
    let query = "";
    if (Object.keys(payload).length > 0) {
      let urlparams = new URLSearchParams();
      for(const key in payload) {
        if(payload[key]) {
          urlparams.append(key, payload[key]);
        }
      }
      if([...urlparams.entries()].length > 0) {
        query += `?${urlparams.toString()}`;
      }
    }
    return api.get(`/admin/banner/${query}`);
  },
  
  getBanner: (bannerId) => {
    return api.get(`/admin/banner/${bannerId}`);
  },
  
  addBanner: (payload) => {
    return api.post(`/admin/banner`, payload);
  },
  
  editBanner: (bannerId, payload) => {
    return api.put(`/admin/banner/${bannerId}`, payload);
  },
  
  deleteBanner: (bannerId) => {
    return api.delete(`/admin/banner/${bannerId}`);
  }
};

export default bannerService;
